import { Spinner } from '@fluentui/react-components';
import { FabricContext } from '@idmc-ms-fabric/integration';
import { FC } from 'react';

import Initializei18n from './component/shared/i18n/Initializei18n';
import { IDQACacheProvider } from './context/business/IDQACache/IDQACacheContext';
import IDQALoggerContext from './context/business/IDQAlogger/IDQALoggerContext';
import AppRouter from './routes/AppRouter';
import useStaticStyles from './styles/GlobalStyles';

const App: FC = () => {
	useStaticStyles();
	return (
		<IDQALoggerContext>
			<IDQACacheProvider>
				<FabricContext loader={<Spinner style={{ height: '100%' }} />}>
					<Initializei18n>
						<AppRouter />
					</Initializei18n>
				</FabricContext>
			</IDQACacheProvider>
		</IDQALoggerContext>
	);
};

export default App;
